import styled from '@emotion/styled'
import colors from '../colors'

export const TabContainer = styled.div`
	background-color: ${colors.white};
	border-radius: 7px;
	padding: 10px;
`

export const TabPicker = styled.div`
	border-bottom: 1px solid ${colors.brightGray};
	display: flex;
`

export const TabItem = styled.div`
	color: ${colors.heather};
	margin-right: 15px;
	padding-bottom: 16px;
	padding-top: 6px;
	&.active {
		color: ${colors.black};
		border-bottom: 2px solid ${colors.indigoBlue};
	}

	&.has_error {
		color: ${colors.pinkRed};
		border-bottom: 2px solid ${colors.pinkRed};
	}
`
